import { Main, Page } from '../../src/components/Layout';
import React, { PureComponent } from 'react';

import BasicMap from './BasicMap';
import Head from 'next/head';
import Header from '../../src/components/Header';
import { withI18N } from '../../src/hoc/index';

class MapPage extends PureComponent {
  render() {
    return (
      <Page map>
        <Head>
          <title key="title">Grand Hôtel-Dieu</title>
        </Head>
        <Header
          image={`/static/images/header-brands.jpg`}
          search={false}
          adaptive
          functional
        />
        <Main>
          <BasicMap />
        </Main>
      </Page>
    );
  }
}

export default withI18N()(MapPage);
